var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16349",
    "data-name": "Group 16349",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_-_Outline",
    "data-name": "Ellipse 2 - Outline",
    d: "M29.5,0A29.5,29.5,0,1,0,59,29.5,29.5,29.5,0,0,0,29.5,0m0-3A32.491,32.491,0,0,1,52.481,52.481,32.5,32.5,0,1,1,16.849-.445,32.3,32.3,0,0,1,29.5-3Z",
    fill: "#00101f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "forklift_1_",
    "data-name": "forklift (1)",
    transform: "translate(13 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    d: "M16.856,18.046H8.863A3.866,3.866,0,0,1,5,14.183V5.053A1.054,1.054,0,0,1,6.053,4h4.6A3.867,3.867,0,0,1,14.3,6.577l3.552,10.064a1.054,1.054,0,0,1-.993,1.4ZM7.107,6.107v8.076a1.758,1.758,0,0,0,1.756,1.756h6.5L12.311,7.278a1.757,1.757,0,0,0-1.656-1.171Z",
    transform: "translate(2.023 -2.595)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M22.122,22.641h-3.16a1.053,1.053,0,0,1,0-2.107h2.107V15.618H10.885A3.865,3.865,0,0,1,7.04,12.107H3.863a1.758,1.758,0,0,0-1.756,1.756v6.321a.355.355,0,0,0,.351.351H3.511a1.053,1.053,0,1,1,0,2.107H2.458A2.461,2.461,0,0,1,0,20.183V13.863A3.866,3.866,0,0,1,3.863,10H8.076A1.054,1.054,0,0,1,9.13,11.053v.7a1.758,1.758,0,0,0,1.756,1.756H22.122a1.054,1.054,0,0,1,1.053,1.053v7.023A1.054,1.054,0,0,1,22.122,22.641Z",
    transform: "translate(0 -0.168)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    d: "M11.017,19.607H6.8a1.053,1.053,0,0,1,0-2.107h4.214a1.053,1.053,0,0,1,0,2.107Z",
    transform: "translate(2.326 2.866)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    d: "M26.588,25.473H16.053A1.054,1.054,0,0,1,15,24.42V4.053a1.053,1.053,0,1,1,2.107,0V23.366h9.481a1.053,1.053,0,0,1,0,2.107Z",
    transform: "translate(6.069 -3)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    d: "M5.511,23.023a3.511,3.511,0,1,1,3.511-3.511A3.515,3.515,0,0,1,5.511,23.023Zm0-4.916a1.4,1.4,0,1,0,1.4,1.4A1.406,1.406,0,0,0,5.511,18.107Z",
    transform: "translate(0.809 2.259)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12045",
    "data-name": "Path 12045",
    d: "M12.511,23.023a3.511,3.511,0,1,1,3.511-3.511A3.515,3.515,0,0,1,12.511,23.023Zm0-4.916a1.4,1.4,0,1,0,1.4,1.4A1.406,1.406,0,0,0,12.511,18.107Z",
    transform: "translate(3.641 2.259)",
    fill: "#1a00e3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b623232177842fe153c844b3ac53a27f.svg";
export { ForwardRef as ReactComponent };